import Component from "gia/Component";
import Env from "../base/env.js";
import Channels from "../base/channels";
import { CountryProvinceSelector } from "@shopify/theme-addresses";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    //! Fns
    this.makeCountriesOptions();
    this.makeToggles();
    this.events();
  }

  events() {
    const $triggersDelete = this.DOM.view.querySelectorAll(".jsAddress-delete");
    for (let i = 0; i < $triggersDelete.length; i++) {
      const $trigger = $triggersDelete[i];

      $trigger.addEventListener("click", () => {
        const target = $trigger.getAttribute("data-target");
        const confirmMessage = $trigger.getAttribute("data-confirm-message");

        if (
          confirm(
            confirmMessage || "Are you sure you wish to delete this address?"
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: "delete" },
          });
        }
      });
    }
  }

  makeCountriesOptions() {
    const countryProvinceSelector = new CountryProvinceSelector(
      window.allCountryOptionTags
    );
    const countrySelector = this.DOM.view.querySelector("#AddressCountryNew");
    const provinceSelector = this.DOM.view.querySelector("#AddressProvinceNew");
    const provinceWrapper = this.DOM.view.querySelector(
      "#AddressProvinceWrapperNew"
    );

    countryProvinceSelector.build(countrySelector, provinceSelector, {
      onCountryChange: (provinces) =>
        provinceWrapper.classList.toggle("disabled", !provinces.length),
    });

    const countriesSelector = this.DOM.view.querySelectorAll(".jsCountryEdit");
    const provincesSelector = this.DOM.view.querySelectorAll(".jsProvinceEdit");
    const provincesWrapper = this.DOM.view.querySelectorAll(
      ".jsProvinceWrapperEdit"
    );

    for (let i = 0; i < countriesSelector.length; i++) {
      const instanceSelector = new CountryProvinceSelector(
        window.allCountryOptionTags
      );
      const country = countriesSelector[i];
      const province = provincesSelector[i];
      const wrapper = provincesWrapper[i];

      instanceSelector.build(country, province, {
        onCountryChange: (provinces) =>
          wrapper.classList.toggle("disabled", !provinces.length),
      });
    }

    // Init Country Selected
    setTimeout(() => {
      countrySelector.options[0].selected = "selected";
    }, 250);
  }

  makeToggles() {
    const $triggers = this.DOM.view.querySelectorAll(".jsAddress-edit-toggle");
    const $triggersClose = this.DOM.view.querySelectorAll(
      ".jsAddress-edit-close"
    );

    for (let i = 0; i < $triggers.length; i++) {
      const $trigger = $triggers[i];
      const $receptor = this.DOM.view.querySelector(
        `#${$trigger.getAttribute("aria-owns")}`
      );

      $trigger.addEventListener("click", () => {
        $receptor.classList.toggle("hidden");
      });
    }

    for (let i = 0; i < $triggersClose.length; i++) {
      const $trigger = $triggersClose[i];
      const $receptor = this.DOM.view.querySelector(
        `#${$trigger.getAttribute("data-receptor")}`
      );

      $trigger.addEventListener("click", () => {
        $receptor.classList.add("hidden");
      });
    }
  }

  unmount() {}
}
